<h1 mat-dialog-title>{{data.title}}</h1>
<mat-dialog-content>
    <marlenka-wysiwyg-view [html]="data.content"></marlenka-wysiwyg-view>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Zavřít</button>
</mat-dialog-actions>